export var UserTypeVoData;
(function (UserTypeVoData) {
    UserTypeVoData["BOT"] = "BOT";
    UserTypeVoData["ANONYMOUS"] = "ANONYMOUS";
    UserTypeVoData["USER_TYPE_1"] = "USER_TYPE_1";
    UserTypeVoData["USER_TYPE_2"] = "USER_TYPE_2";
    UserTypeVoData["USER_TYPE_3"] = "USER_TYPE_3";
    UserTypeVoData["USER_TYPE_4"] = "USER_TYPE_4";
    UserTypeVoData["USER_TYPE_5"] = "USER_TYPE_5";
    UserTypeVoData["USER_TYPE_6"] = "USER_TYPE_6";
    UserTypeVoData["USER_TYPE_7"] = "USER_TYPE_7";
    UserTypeVoData["USER_TYPE_8"] = "USER_TYPE_8";
    UserTypeVoData["USER_TYPE_9"] = "USER_TYPE_9";
    UserTypeVoData["USER_TYPE_10"] = "USER_TYPE_10";
    UserTypeVoData["CUSTOMER_TYPE_1"] = "CUSTOMER_TYPE_1";
    UserTypeVoData["CUSTOMER_TYPE_2"] = "CUSTOMER_TYPE_2";
    UserTypeVoData["CUSTOMER_TYPE_3"] = "CUSTOMER_TYPE_3";
    UserTypeVoData["CUSTOMER_TYPE_4"] = "CUSTOMER_TYPE_4";
    UserTypeVoData["CUSTOMER_TYPE_5"] = "CUSTOMER_TYPE_5";
    UserTypeVoData["CUSTOMER_TYPE_6"] = "CUSTOMER_TYPE_6";
    UserTypeVoData["CUSTOMER_TYPE_7"] = "CUSTOMER_TYPE_7";
    UserTypeVoData["CUSTOMER_TYPE_8"] = "CUSTOMER_TYPE_8";
    UserTypeVoData["CUSTOMER_TYPE_9"] = "CUSTOMER_TYPE_9";
    UserTypeVoData["CUSTOMER_TYPE_10"] = "CUSTOMER_TYPE_10";
})(UserTypeVoData || (UserTypeVoData = {}));
//# sourceMappingURL=user-type-vo-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/vo/user/user-type-vo-data.js
// module id = 951
// module chunks = 14